export default "/images/eae5c71ea00627b0e6cb52e0b1119009.avif";